
import { ReactNode } from 'react';
import { LucideIcon } from 'lucide-react';
// import { NavLink } from 'react-router-dom';

interface BrandPillarProps {
  icon: LucideIcon;
  title: string;
  description: string;
  linkTo: string;
  linkText: string;
}

const BrandPillar = ({
  icon: Icon,
  title,
  description,
  linkTo,
  linkText,
}: BrandPillarProps) => {
  return (
    <div className="bg-white rounded-lg p-6 md:p-8 transition-all duration-300 hover:translate-y-[-5px] hover:shadow-2xl border border-adv-darkGray/10">
      <div className="rounded-full bg-adv-orange/20 w-12 h-12 flex items-center justify-center mb-6">
        <Icon className="text-adv-orange" size={24} />
      </div>
      <h3 className="heading-sm text-adv-dark mb-3">{title}</h3>
      <p className="text-adv-darkGray mb-5">{description}</p>
      <a href={linkTo} className="text-adv-orange hover:text-adv-orange/80 font-medium inline-flex items-center group">
        {linkText}
        <svg className="ml-1 w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </a>
    </div>
  );
};

export default BrandPillar;
